import { Injectable } from '@angular/core';
import { RingBuffer } from 'ring-buffer-ts';

export interface averageSample {

}

@Injectable({
  providedIn: 'root'
})
export class MathHelperService {

constructor() { }

  /**
   * Média sobre as amostras de uma janela deslizante
   * @param sample 
   * @param rBuffer 
   * @returns 
   */
  // movingWindowAverage(sample: number, rBuffer: RingBuffer<number>) {

  //   rBuffer.add(sample);
  //   // if (this.averageFr < 10) rBuffer.add(sample);
  //   // if (this.averageFr < 5) rBuffer.add(sample);
  //   const buff: Array<number> = rBuffer.toArray();
  //   var integral = 0;
  //   buff.forEach(element => {
  //     integral += element;
  //   });

  //   if (buff.length > 0) return integral / buff.length;
  //   else return 0;
  // }

  movingWindowAverage(sample: number, rBuffer: RingBuffer<number>, depth: number = rBuffer.getSize()) {
    rBuffer.add(sample);
    // if (this.averageFr < 10) rBuffer.add(sample);
    // if (this.averageFr < 5) rBuffer.add(sample);
    const buff: Array<number> = rBuffer.toArray();
    var integral = 0;
    buff.forEach(element => {
      integral += element;
    });

    for (let index = buff.length - depth; index < buff.length; index++) {
      integral += buff[index];
    }

    if (buff.length > 0) return integral / buff.length;
    else return 0;
  }

    /**
   * Desvio padrão sobre amostras de janela deslizante
   * @param sample 
   * @param rBuffer 
   * @returns 
   */
    movingWindowDeviation(sample: number, rBuffer: RingBuffer<number>) {

      rBuffer.add(sample);
      // if (this.averageFr < 10) rBuffer.add(sample);
      // if (this.averageFr < 5) rBuffer.add(sample);
      const array: Array<number> = rBuffer.toArray();
  
      const n = array.length
      const mean = array.reduce((a, b) => a + b) / n
      return Math.sqrt(array.map(x => Math.pow(x - mean, 2)).reduce((a, b) => a + b) / n)
    }

  distanceTo(a: any, b: any) {
    return  Math.sqrt(Math.pow(b.x - a.x, 2) + Math.pow(b.y - a.y, 2) + Math.pow(b.z - a.z, 2));
  }

  distanceTo2D(a: any, b: any) {
    return  Math.sqrt(Math.pow(b.x - a.x, 2) + Math.pow(b.y - a.y, 2));
  }
}
